import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { css } from "@emotion/react";

// Import css files
import "swiper/css";
import "./imageSwiper.css";

type Props = {
  images?: string[];
  slidesPerView?: number;
  speed?: number;
  rtl?: boolean; // 右から左にスライドするかどうか
  top?: number;
};

const ImageSwiper: React.FC<Props> = ({
  images = [],
  slidesPerView = 4 / 3,
  speed = 5250,
  rtl = false,
  top = 0,
}) => {
  return (
    <Swiper
      loop={true}
      className="image-slider"
      css={swiperStyle(top)}
      autoplay={{
        delay: 0,
        reverseDirection: !rtl,
      }}
      slidesPerView={slidesPerView}
      speed={speed}
      modules={[Autoplay]}
    >
      {images &&
        images.map((image) => (
          <SwiperSlide>
            <img css={imgStyle} src={process.env.REACT_APP_BASE_PATH + image} />
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

const swiperStyle = (top: number) => css`
  position: relative;
  top: ${top}px;
  transition-timing-function: linear;
`;

const imgStyle = css`
  width: 100%;
  height: auto;
`;

export default ImageSwiper;
